enum ContractCancellationReasons {
  CUSTOMER_CANCELLATION = 'Customer Cancellation',
  ADMIN_CANCELLATION = 'Admin Cancellation',
  REPOSSESSION = 'Repossession',
  WRITE_OFF = 'Write-Off',
  OTHER = 'Other',
}

export default ContractCancellationReasons;
export type VerifyCancellationReason = Utils.VerifyExtends<
  Model.Enum.ContractCancellationReasons,
  Utils.ValueOf<typeof ContractCancellationReasons>
>;
